import SideMenuButton from "@navigation/SideMenuButton";
import MenuButton from "./MenuButton";
import MenuInception from "./MenuInception";
import { Project, ProjectHistoryEvent } from "types";
import { Timestamp } from "firebase/firestore";
import { showNotification } from "context/notification.service";
import { User } from "types/user";
import { useProjectStore } from "@store/projectStore";

const projectStatuses = [
  { value: "not_started", label: "En attente" },
  { value: "in_progress", label: "En cours" },
  { value: "delivered", label: "Livré" },
  { value: "sav", label: "SAV" },
] as const;

const statusLabels: Record<string, string> = {
  not_started: "En attente",
  in_progress: "En cours",
  delivered: "Livré",
  sav: "SAV",
};

export const ActionsMenuButton = ({
  project,
  setProject,
  modalsOpen,
  setModalsOpen,
  userData,
}: {
  project: Project;
  setProject: (project: Project) => void;
  modalsOpen: {
    modify: boolean;
    delete: boolean;
    addDocument: boolean;
    addPhoto: boolean;
    compteRendu: boolean;
    changeStatus: boolean;
    sendEmail: boolean;
  };
  setModalsOpen: React.Dispatch<
    React.SetStateAction<{
      modify: boolean;
      delete: boolean;
      addDocument: boolean;
      addPhoto: boolean;
      compteRendu: boolean;
      changeStatus: boolean;
      sendEmail: boolean;
    }>
  >;
  userData?: User | null;
}) => {
  const { updateProject } = useProjectStore();

  const handleChangeStatus = (newStatus: string) => {
    if (project.status === newStatus) return;

    const historyEvent: ProjectHistoryEvent = {
      id: `event_${Date.now()}`,
      action: `a changé le statut en "${statusLabels[newStatus] || newStatus}"`,
      user: {
        id: userData?.id || "unknown",
        display_name: userData?.infos.display_name || "Utilisateur",
        photo_url: userData?.customization.photo_url,
      },
      date: Timestamp.now(),
    };

    const updated = {
      ...project,
      status: newStatus,
      history_events: [historyEvent, ...project.history_events],
    };

    setProject(updated);
    updateProject(updated);

    showNotification({
      type: "success",
      message: `Statut changé en "${statusLabels[newStatus] || newStatus}"`,
    });
  };

  return (
    <>
      <MenuButton label="Actions">
        <div className="flex flex-col ">
          <div className="flex flex-col p-1">
            <div className="text-h2 text-neutral-400 p-2">ACTIONS RAPIDES</div>
            <SideMenuButton
              size="large"
              label="Modifier"
              name="modify"
              onClick={() => setModalsOpen({ ...modalsOpen, modify: true })}
            ></SideMenuButton>
            <SideMenuButton
              size="large"
              label="Supprimer"
              name="delete"
              onClick={() => setModalsOpen({ ...modalsOpen, delete: true })}
            ></SideMenuButton>
          </div>
          <div className="flex flex-col border-t-1 p-1 ">
            <div className="text-h2 text-neutral-400 p-2">COMMUNICATION</div>
            <SideMenuButton
              size="large"
              label="Envoyer un email"
              name="email"
              onClick={() =>
                setModalsOpen({ ...modalsOpen, sendEmail: true })
              }
            ></SideMenuButton>
          </div>
          <div className="flex flex-col border-t-1 p-1 ">
            <div className="text-h2 text-neutral-400 p-2">DOSSIER</div>
            <SideMenuButton
              size="large"
              label="Ajouter document"
              name="plus"
              onClick={() =>
                setModalsOpen({ ...modalsOpen, addDocument: true })
              }
            ></SideMenuButton>
            <SideMenuButton
              size="large"
              label="Ajouter photo"
              name="plus"
              onClick={() => setModalsOpen({ ...modalsOpen, addPhoto: true })}
            ></SideMenuButton>
            <SideMenuButton
              size="large"
              label="Compte rendu"
              name="file"
              onClick={() =>
                setModalsOpen({ ...modalsOpen, compteRendu: true })
              }
            ></SideMenuButton>
            <MenuInception
              size="large"
              label="Changer le statut"
              name="restart"
            >
              <div className="flex flex-col">
                {projectStatuses.map((s) => (
                  <SideMenuButton
                    key={s.value}
                    size="large"
                    label={s.label}
                    name={project.status === s.value ? "done2" : undefined}
                    onClick={() => handleChangeStatus(s.value)}
                  />
                ))}
              </div>
            </MenuInception>
          </div>
        </div>
      </MenuButton>
    </>
  );
};
